import axios from 'axios';

const config = {BASE_URL:'http://192.168.1.111:2901/api/', header: {}};

const api = axios.create({baseURL: config.BASE_URL, headers: config.header});

export default api;